// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import TenueProfileLayout from './TenueProfileLayout';

import TenueService from '../../services/TenueService';

const DeleteTenue = () => {
	const [tenue, setTenue] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([TenueService.getTenue(id)]).then(([tenueData]) => {
			setTenue(tenueData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the TenueService to delete the Tenue
			await TenueService.deleteTenue(id);

			// Redirect the user to the list of Tenues
			navigate('/finances/tenues');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations de la Tenue ",
				error
			);
		}
	};

	return (
		<TenueProfileLayout>
			{tenue && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{tenue.titre || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement cette Tenue.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez cette Tenue, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le Tenue
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</TenueProfileLayout>
	);
};

export default DeleteTenue;
